import { useState } from "react";
import { isEqual } from "lodash";

import { StatusQuickFilter } from "./interfaces";
import { PositionDateQuickFilter } from "../PositionDateQuickfilter/interfaces";

export const useStatusQuickFilter = (
  position: boolean,
  setPositionDateQuickFilter?: SetPositionDateQuickFilterType
) => {
  const [quickFilter, setQuickFilter] = useState<StatusQuickFilter>({
    statuses: {
      isTrueOrFalse: position,
    },
  });

  const handleChangeQuickFilter = (filter: keyof StatusQuickFilter, value: StatusQuickFilter["statuses"]) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));

    if (value.isTrueOrFalse) {
      setPositionDateQuickFilter &&
        setPositionDateQuickFilter("positionDate", {
          fromMonthsAgo: null,
        });
    }
  };

  return {
    statusQuickFilter: quickFilter,
    setStatusQuickFilter: handleChangeQuickFilter,
  };
};

type SetPositionDateQuickFilterType = (
  filter: keyof PositionDateQuickFilter,
  value: PositionDateQuickFilter["positionDate"]
) => void;
